// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type AuswertungUnteraufgabenListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetAuswertungUnteraufgabe(): (
  auswertungAufgabeId: string
) => Promise<AuswertungUnteraufgabenListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (auswertungAufgabeId) =>
      (await getAPI()).auswertungUnteraufgabe.getAuswertungUnteraufgabe({
        auswertungAufgabeId,
      }),
    [getAPI]
  );
}
